import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import { Breadcrumb } from 'gatsby-plugin-breadcrumb'

// Components
import { TitleDefault, ButtonAlt } from 'components/Elements'
import CustomLink from 'components/CustomLink'

// Images
import arrow from 'img/arrow-right.svg'

import { map as _map, sortBy as _sortBy } from 'lodash'

import './SidebarMenu.scss'

const SidebarMenu = ({ currentPageID }) => {
  const {
    allWordpressPage: { edges: pages },
  } = useStaticQuery(graphql`
    {
      allWordpressPage(sort: {fields: acf___sortnumber, order: ASC}) {
        edges {
          node {
            title
            path
            wpId: wordpress_id
            parent: parent_element {
              wpId: wordpress_id
            }
            acf {
              sortnumber
            }
          }
        }
      }
    }
  `)

  const currentPage = pages.find(({ node: { wpId } }) => wpId === currentPageID)

  const getTopPage = parentId => {
    const parentPage = pages.find(({ node: { wpId } }) => wpId === parentId)

    if(parentPage.node.parent) {
      return getTopPage(parentPage.node.parent.wpId)
    }

    return parentPage
  }

  const getSubPages = parentId => {
    return pages.filter(({ node: { parent } }) => parent && parent.wpId === parentId)
  }

  const topPage = getTopPage(currentPage.node.parent.wpId)

  const buildMenu = pageId => {
    const menu = {}
    const topPageSubs = getSubPages(pageId)

    if(topPageSubs) {
      topPageSubs.forEach(({ node }) => {
        menu[node.wpId] = { node, sub: {} }
        menu[node.wpId].sub = buildMenu(node.wpId)
        menu[node.wpId].sortnumber = parseFloat(node.acf.sortnumber || 0)
      })
    }

    return menu
  }

  let menu = buildMenu(topPage.node.wpId)

  menu = _sortBy(menu, [({ sortnumber }) => sortnumber])

  return (
    <>
      <div className="col-12 p-0">
        <ul className="sidebar-menu">
          {_map(menu, ({ node, sub }) => {
            const subMenu = _sortBy(sub, [({ sortnumber }) => sortnumber])

            return (
              <li key={node.wpId} className="sidebar-menu-item">
                <CustomLink
                  to={node.path}
                  className={`pl-3 ${
                    node.sub ? ' has-children' : ''
                  }`}
                >
                  {node.title}
                </CustomLink>
                {subMenu && (
                  <ul className="submenu pt-3 pb-1">
                    {_map(subMenu, ({ node: subNode }) => (
                      <li key={subNode.wpId} className="submenu-item">
                        <img src={arrow} width="7" alt="" />
                        <CustomLink to={subNode.path}>
                          {subNode.title}
                        </CustomLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    </>
  )
}

export default SidebarMenu
